<div
  class="container-shadow"
  (click)="$event.stopPropagation(); clickedHandler()" tappable>
  <i [class]="iconName"></i>
</div>
